import React from 'react';
import PropTypes from 'prop-types';

import TextField from './TextField';
import zipCodeValidator from '../../../helpers/validators/zipCodeValidator';

export default class ZIPCodeField extends React.PureComponent {
    static propTypes = {
        /** html id required to connect the input with the label */
        id: PropTypes.string.isRequired,

        /** Label contents, usually text */
        label: PropTypes.node
    };

    static defaultProps = {
        label: 'ZIP Code'
    };

    textFieldRef = React.createRef();

    validate = () => {
        return this.textFieldRef.current.validate();
    }

    render() {
        const { id, label, ...rest } = this.props;

        return (
            <TextField
                ref={this.textFieldRef}
                id={id}
                label={label}
                validator={zipCodeValidator}
                shouldReformatValue
                maxLength={10}
                {...rest} />
        );
    }
}
